import { render, staticRenderFns } from "./AddLinkModal.vue?vue&type=template&id=2289d737&scoped=true&"
import script from "./AddLinkModal.vue?vue&type=script&lang=js&"
export * from "./AddLinkModal.vue?vue&type=script&lang=js&"
import style0 from "./AddLinkModal.vue?vue&type=style&index=0&id=2289d737&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2289d737",
  null
  
)

export default component.exports